import { match } from 'ts-pattern';

type SubmitConfig = {
  submitButtonText: string;
};

type GetSubmitConfigParams = {
  operation: 'create' | 'edit' | 'restart' | 'init';
};

export function getSubmitConfig({ operation }: GetSubmitConfigParams): SubmitConfig {
  return match(operation)
    .with('create', () => ({
      submitButtonText: 'Create contest',
    }))
    .with('edit', () => ({
      submitButtonText: 'Save changes',
    }))

    .with('restart', () => ({
      submitButtonText: 'Create contest',
    }))
    .with('init', () => ({
      submitButtonText: 'Continue',
    }))
    .exhaustive();
}
